import { Controller } from '@hotwired/stimulus';

export default class DropdownButtonController extends Controller {
  static targets = ['dropdown', 'button'];
  dropdown = null;

  dropdownReady(e) {
    this.dropdown = e.detail.dropdown;
    this.updateButtonState();
  }

  dropdownUpdate() {
    this.updateButtonState();
  }

  dropdownBlur() {
    this.updateButtonState();
  }

  updateButtonState() {
    if (!this.hasDropdownTarget || !this.hasButtonTarget || !this.dropdown) return;
    const selection = this.dropdown.getSelection();
    this.buttonTarget.disabled = !selection;
  }
}
